<div class="transport-options-editor no-field-space">
    <sc-padding>
        <form [formGroup]="optionFormGroup">
            <mat-slide-toggle formControlName="optional" name="optional">
                {{'optional' | translate: ['tmc-yard.entity.transport-option.optional',
                translationService.language]}}
            </mat-slide-toggle>
            <sc-content-spacer [vertical]="true"></sc-content-spacer>
            <mat-form-field *ngIf="showMinimumSelectedOptions" appearance="fill">
                <mat-label>{{'minimum non-optional transport-options' | translate:
                    ['tmc-yard.entity.transport-option.minimum-selected-options',
                    translationService.language]}}</mat-label>
                <input matInput appPositiveInteger type="number" min="0" formControlName="minimumSelectedOptions"
                    name="minimumSelectedOptions" [required]="true" />
            </mat-form-field>
        </form>
    </sc-padding>
</div>